import { deleteRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function deleteDeviationTypeRequest(idToDelete) {
	let url = maintenance.getDeviationTypesByIdPath(idToDelete);
	return deleteRequest(url);
}